export default "__VITE_ASSET__eFpujzqK__"